export interface StructuredDataProps {
    type: 'Organization' | 'WebSite' | 'BreadcrumbList' | 'SoftwareApplication' | 'Article';
    data: any;
}

export const generateOrganizationSchema = () => {
    return {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'HyVay',
        url: 'https://hyvay.com',
        logo: 'https://hyvay.com/images/logo.png',
        description: 'Platform No-Code App Builder untuk membuat aplikasi dengan mudah dan cepat',
        sameAs: [
            // Add your social media URLs here
            // 'https://facebook.com/hyvay',
            // 'https://twitter.com/hyvay',
            // 'https://linkedin.com/company/hyvay',
        ],
        contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'Customer Support',
            email: 'support@hyvay.com',
        },
    };
};

export const generateWebSiteSchema = () => {
    return {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'HyVay',
        url: 'https://hyvay.com',
        description: 'Platform No-Code App Builder - Bikin Aplikasi, Sat-Set Jadi!',
        potentialAction: {
            '@type': 'SearchAction',
            target: {
                '@type': 'EntryPoint',
                urlTemplate: 'https://hyvay.com/?q={search_term_string}',
            },
            'query-input': 'required name=search_term_string',
        },
    };
};

export const generateSoftwareApplicationSchema = (appData: {
    name: string;
    description?: string;
    url: string;
}) => {
    return {
        '@context': 'https://schema.org',
        '@type': 'SoftwareApplication',
        name: appData.name,
        description: appData.description || `Aplikasi ${appData.name} dibuat dengan HyVay`,
        url: appData.url,
        applicationCategory: 'WebApplication',
        operatingSystem: 'Web Browser',
        offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'IDR',
        },
        creator: {
            '@type': 'Organization',
            name: 'HyVay',
            url: 'https://hyvay.com',
        },
    };
};

export const generateBreadcrumbSchema = (items: Array<{ name: string; url: string }>) => {
    return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.name,
            item: item.url,
        })),
    };
};

export const generateArticleSchema = (articleData: {
    title: string;
    description: string;
    image?: string;
    datePublished: string;
    dateModified?: string;
    author?: string;
}) => {
    return {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: articleData.title,
        description: articleData.description,
        image: articleData.image || 'https://hyvay.com/images/logo.png',
        datePublished: articleData.datePublished,
        dateModified: articleData.dateModified || articleData.datePublished,
        author: {
            '@type': 'Person',
            name: articleData.author || 'HyVay Team',
        },
        publisher: {
            '@type': 'Organization',
            name: 'HyVay',
            logo: {
                '@type': 'ImageObject',
                url: 'https://hyvay.com/images/logo.png',
            },
        },
    };
};

// Helper to inject structured data into the page
export const injectStructuredData = (schema: any) => {
    if (typeof window === 'undefined') return;

    const scriptId = 'structured-data';
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;

    if (!script) {
        script = document.createElement('script');
        script.id = scriptId;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
    }

    script.textContent = JSON.stringify(schema);
};
